import React from 'react';
import {
    Bar,
    Title,
    BackIcon,
    RightIcon,
} from './Topbar.style';

const Topbar = ({
    title,
    rightIcon = '',
    shadow = true,
    showLeftIcon = true,
    align = 'center',
    goBack,
    isBlack,
    custom = false,
}) => {

    return (
        <Bar isBlack={isBlack} id='top-bar' shadow={shadow ? 'hide' : 'hide'} transparent={custom ? 1 : 0}>
            {showLeftIcon && <BackIcon onClick={() => goBack()} />}
            <Title align={align}>
                {custom ? '' : title}
            </Title>
            {rightIcon &&
                <RightIcon>
                    {rightIcon}
                </RightIcon>
            }
        </Bar>
    );
}

export default Topbar;